<template>
  <v-container fluid class="pa-4">
    <h2 class="text-h5 font-weight-bold mb-1">Autodiagnóstico SAC</h2>
    <p class="grey--text mb-3">Configuración del cuestionario, dashboard agregado y niveles de puntaje.</p>

    <v-card>
      <v-tabs :value="activeTab" color="primary" grow>
        <v-tab :to="tab.dashboard" exact>
            <v-icon left>mdi-chart-line</v-icon> Dashboard
        </v-tab>
        <v-tab :to="tab.config" exact>
            <v-icon left>mdi-clipboard-pulse-outline</v-icon> Configuración
        </v-tab>
        <v-tab :to="tab.levels" exact>
            <v-icon left>mdi-format-list-numbered</v-icon> Niveles
        </v-tab>
      </v-tabs>
      <v-divider />
      <router-view />
    </v-card>
  </v-container>
</template>

<script>
export default {
    name: 'SacAdmin',
    computed: {
        tab() {
            return {
                dashboard: '/sac/admin/dashboard',
                config: '/sac/admin/config',
                levels: '/sac/admin/config/levels',
            };
        },
        activeTab() {
            const path = this.$route && this.$route.path;
            if (!path) return 'dashboard';
            if (path.startsWith('/sac/admin/config/levels')) return 'levels';
            if (path.startsWith('/sac/admin/config')) return 'config';
            if (path.startsWith('/sac/admin/dashboard')) return 'dashboard';
            return 'dashboard';
        },
    },
};
</script>
